<template>
  <v-layout align-space-around justify-start fill-height column class="pt-5">
    <v-slide-x-transition>
      <v-card class="ml-4 mr-4 mb-4">
        <v-card-text>
          <v-layout wrap justify-space-between>
            <v-flex xs10 md11>
              <v-layout wrap justify-space-around>
                <v-flex xs11 sm5 md3 lg2 xl2>
                  <v-text-field
                    label="Código do veículo"
                    v-model="id_veiculo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs11 sm5 md4 lg3 xl2>
                  <v-select
                    label="Status"
                    :items="
                      [
                        { text: 'Aberto', value: 1 },
                        { text: 'Encerrado', value: 2 },
                        { text: 'Cancelado', value: 3 },
                        { text: 'Em andamento', value: 4 },
                        { text: 'Concluído', value: 5 }
                      ]
                    "
                    v-model="status"
                    item-text="text"
                    item-value="value"
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex xs11 sm5 md4 lg3 xl2>
                  <v-select
                    label="Responsável"
                    :items="
                      [
                        { text: 'Cliente', value: 1 },
                        { text: 'Empresa', value: 2 }
                      ]
                    "
                    v-model="tipo_responsavel"
                    item-text="text"
                    item-value="value"
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex xs11 sm5 md4 lg3 xl2>
                  <v-text-field
                    v-show="tipo_responsavel"
                    :label="tipo_responsavel === 1 ? 'ID do Cliente' : 'CNPJ da Empresa'"
                    :mask="tipo_responsavel === 1 ? '' : '##.###.###/####-##'"
                    v-model.lazy="responsavel"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs11 sm5 md4 lg3 xl2>
                  <v-select
                      :label="`${selectOpcoes} de início`"
                      :items="options"
                      item-text="title"
                      item-value="value"
                      v-model="selectOpcoes"
                    >
                    </v-select>
                </v-flex>
                <v-flex xs11 sm5 md4 lg3 xl2>
                  <v-menu
                    ref="menuDataInicial"
                    v-model="menuDataInicial"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-combobox
                        v-if="opcoes.dia"
                        v-model="opcoes.data_relatorio"
                        :label="'Data de Início'"
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        @blur="date = parseDate(opcoes.data_relatorio)"
                        prepend-icon="event"
                        required
                        v-on="on"
                        clearable
                      ></v-combobox>
                      <v-combobox
                        v-else
                        v-model="opcoes.mes_relatorio"
                        :label="'Mês de início'"
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        @blur="month = parseDate(opcoes.mes_relatorio)"
                        prepend-icon="event"
                        required
                        v-on="on"
                        clearable
                      ></v-combobox>
                    </template>
                    <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                    <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs2 md1 align-self-center>
              <v-btn fab small color="info" @click="pegarLeiloes(true)">
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-slide-x-transition>
      <v-data-table
        :headers="[
          {
            sortable: false
          },
          {
            text: 'Veículo',
            value: 'veiculo_leiloado',
            sortable: false
          },
          {
            text: 'Responsável',
            value: 'empresa',
            sortable: false
          },
          {
            text: 'Data de início',
            align: 'left',
            sortable: false,
            value: 'data_inicio'
          },
          {
            text: 'Data de encerramento',
            align: 'left',
            sortable: false,
            value: 'data_fim'
          },
          {
            text: 'Quantidade de lances',
            align: 'center',
            sortable: false,
            value: 'qtd_lances'
          },
          {
            text: 'Status',
            value: 'status',
            sortable: false,
            align: 'left'
          },
          {
            align: 'right',
            sortable: false
          }
        ]"
        hide-actions
        :items="leiloes"
        :hide-headers="!leiloes || !leiloes.length"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="totalItens"
        no-data-text="Você ainda não possui leilões cadastrados"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">
              <v-icon>pan_tool</v-icon>
            </td>
            <td class="text-xs-left">
              <template v-if="props.item.veiculo_leiloado.modelo && props.item.veiculo_leiloado.marca">
                {{props.item.veiculo_leiloado.modelo.split(' ')[0] || ''}}/{{props.item.veiculo_leiloado.marca}}
              </template>
            </td>
            <td class="text-xs-left">
              <template v-if="props.item.empresa">
                {{ props.item.empresa.nome_fantasia }}
              </template>
              <template v-if="props.item.cliente">
                {{ props.item.cliente.pessoa.nome_completo }}
              </template>
            </td>
            <td>
              {{ props.item.data_inicio | formatDate('DD/MM/YYYY')  }}
            </td>
            <td>{{ props.item.data_fim | formatDate('DD/MM/YYYY') }}</td>
            <td class="text-center">
              {{  props.item.qtd_lances }}
            </td>
            <td class="text-xs-left">
              <v-tooltip bottom v-if="props.item.status==3">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" dark v-on="on">cancel</v-icon>
                </template>
                <span>Cancelado</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="props.item.status==5">
                <template v-slot:activator="{ on }">
                  <v-icon color="teal" dark v-on="on">check_circle</v-icon>
                </template>
                <span>Concluído</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="props.item.status==2 || verificarEncerramento(props.item.data_fim)">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">timer_off</v-icon>
                </template>
                <span>Enderrado</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="props.item.status==1">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on">timer</v-icon>
                </template>
                <span>Em Aberto</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="props.item.status==4">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on">change_circle</v-icon>
                </template>
                <span>Em andamento</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-1"
                    v-on="on"
                    icon
                    flat
                    color="primary"
                    @click="
                      leilaoSelecionado = props.item,
                      dialogVisualizarLeilao = true
                    "
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </template>
                <span>Detalhes do leilão</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-1"
                    v-on="on"
                    icon
                    flat
                    color="info"
                    @click="
                      leilaoSelecionado = props.item,
                      dialogEditarLeilao = true
                    "
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Editar leilão</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-1"
                    v-on="on"
                    icon
                    flat
                    :disabled="props.item.status === 3 || props.item.status === 5"
                    color="red"
                    @click="
                      leilaoSelecionado = props.item,
                      dialogExcluirLeilao = true
                    "
                  >
                    <v-icon>cancel</v-icon>
                  </v-btn>
                </template>
                <span>Excluir leilão</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    <div class="text-xs-center">
      <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
    </div>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="leiloes.length">
          <v-toolbar-title>Abertos: {{ leiloes_data.qtd_aberto }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>Em andamento: {{ leiloes_data.qtd_andamento }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>Encerrados: {{ leiloes_data.qtd_encerrado }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>Cancelados: {{ leiloes_data.qtd_cancelado }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Concluídos: {{ leiloes_data.qtd_concluido }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
    <v-dialog
      v-model="dialogVisualizarLeilao"
      v-if="dialogVisualizarLeilao"
      width="55em"
      scrollable
    >
      <visualizar-leilao
        @fechar="
          dialogVisualizarLeilao = false,
          leilaoSelecionado = undefined
        "
        @carregar="pegarLeiloes(false)"
        @showSuccess="showSuccess"
        @showError="showError"
        :leilaoSelecionado="leilaoSelecionado"
        />
    </v-dialog>
    <v-dialog v-model="dialogExcluirLeilao" width="500">
      <v-card>
        <v-card-title class="justify-center error--text" style="font-size: 1.3em;">
          Você deseja excluir esse leilão?
        </v-card-title>
        <v-card-actions class="justify-space-around">
          <v-btn rounded class="mb-3" @click="dialogExcluirLeilao = false">Não</v-btn>
          <v-btn rounded class="mb-3" @click="excluirLeilao" color="error">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditarLeilao" v-if="dialogEditarLeilao" width="50em">
      <dialog-editar-leilao
        @fechar="dialogEditarLeilao = false, leilaoSelecionado = undefined"
        :leilaoSelecionado="leilaoSelecionado"
        @carregar="pegarLeiloes(false)"
        @showSuccess="showSuccess"
        @showError="showError"
      />
    </v-dialog>
  </v-layout>
</template>
<script>
import VisualizarLeilao from '@/components/dialogs/VisualizarLeilao'
import DialogEditarLeilao from '@/components/dialogs/EditarLeilao'
import moment from 'moment'
export default {
  components: { VisualizarLeilao, DialogEditarLeilao },
  data () {
    return {
      date: moment().format('YYYY-MM-DD'),
      month: new Date().toISOString().substr(0, 10),
      leiloes_data: {},
      dialogEditarLeilao: false,
      dialogVisualizarLeilao: false,
      dialogExcluirLeilao: false,
      leilaoSelecionado: undefined,
      menuDataInicial: false,
      status: undefined,
      data_inicia: undefined,
      id_veiculo: undefined,
      data_encerramento: undefined,
      tipo_responsavel: undefined,
      responsavel: undefined,
      totalItens: 0,
      dates: [],
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        }
      ],
      selectOpcoes: 'dia',
      opcoes: {
        dia: true,
        mes: false,
        data_relatorio: moment().format('DD/MM/YYYY'),
        mes_relatorio: null,
        intervalo_relatorio: [],
        confirmadas: true
      }
    }
  },
  watch: {
    headers (val, oldval) {
      if (val !== null && val !== undefined && val !== oldval) {
        this.pegarLeiloes(false)
      }
    },
    pagination: {
      handler (val, oldval) {
        this.pegarLeiloes(false)
      },
      deep: true
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'mes') {
        this.opcoes.mes = true
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    }
  },
  computed: {
    leiloes () {
      if (!this.leiloes_data || !this.leiloes_data.leiloes) return []
      return this.leiloes_data.leiloes
    },
    headers () {
      return this.$store.getters.headers
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      const count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    }
  },
  methods: {
    showSuccess (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    showError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.mes = false
    },
    verificarEncerramento (data) {
      const agoraRecife = new Date().toLocaleString('pt-BR', { timeZone: 'America/Recife' })
      const dataSeparada = agoraRecife.split(', ')
      const dataFormatada = dataSeparada[0].split('/').reverse().join('-')
      const dataFormatoISO = `${dataFormatada}T${dataSeparada[1]}`
      return new Date(dataFormatoISO) >= new Date(data)
    },
    excluirLeilao () {
      if (!this.leilaoSelecionado) this.showError('Leilão não encontrado.')
      this.$store.dispatch('leilaoVeiculos', {
        method: 'DELETE',
        id: this.leilaoSelecionado.id,
        body: { admin: true }
      }).then(() => {
        this.pegarLeiloes(false)
        this.dialogExcluirLeilao = false
      })
    },
    dataSelecionada () {
      this.menuDataInicial = false
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    pegarLeiloes (isBtn) {
      const data = {
        method: 'GET',
        parametros: {
          page: isBtn ? 1 : this.pagination.page,
          page_size: this.pagination.rowsPerPage,
          admin: true
        }
      }
      if (this.opcoes.dia && this.date) {
        data.parametros.data_inicio__gte = this.date + 'T00:00:00'
        data.parametros.data_inicio__lte = this.date + 'T23:59:59'
      } else if (this.opcoes.mes && this.month && this.month.length) {
        const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
        const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)
        data.parametros.data_inicio__gte = initialDate.toISOString().substr(0, 10) + 'T00:00:00'
        data.parametros.data_inicio__lte = finalDate.toISOString().substr(0, 10) + 'T00:00:00'
      }
      if (this.status) data.parametros.status = this.status
      if (this.id_veiculo) data.parametros.veiculo_leiloado = this.id_veiculo
      if (this.tipo_responsavel === 1) {
        data.parametros.cliente__isnull = false
        if (this.responsavel) {
          data.parametros.cliente__pessoa_id = this.responsavel
        }
      } else if (this.tipo_responsavel === 2) {
        data.parametros.empresa__isnull = false
        if (this.responsavel) {
          data.parametros.empresa__cnpj__icontains = this.responsavel
        }
      }
      this.$store.dispatch('leilaoVeiculos', data).then(json => {
        this.leiloes_data = json.results
        this.totalItens = json.count
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
